export default "__VITE_ASSET__35880a6f__"